import makeStyles from '@mui/styles/makeStyles'

import { TYPES } from '../../../providers/AppNotificationProvider'

const getColorFromType = (type, theme) => {
  if ([TYPES.NEW_CHAT, TYPES.CONVERSATION].includes(type)) {
    return theme.palette.notification.conversation
  }

  if ([TYPES.NOTIFICATION, TYPES.SURVEY].includes(type)) {
    return theme.palette.notification.notification
  }

  switch (type) {
    case TYPES.GROUP:
      return theme.palette.notification.group
    case TYPES.PEER:
      return theme.palette.notification.peer
    default:
      return 'transparent'
  }
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '0.5rem',
    boxShadow: '0 0 5px 1px rgba(0, 0, 0, 0.3)',
    width: '308px !important',
    height: '4rem',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    fontSize: theme.size.sm,
    cursor: 'pointer',

    [theme.breakpoints.up('sm')]: {
      minWidth: '344px !important'
    }
  },

  content: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    padding: '0.125rem'
  },

  type: {
    marginLeft: '3px',
    borderRadius: '100rem',
    width: '4px',
    height: 'calc(100% - 1rem)',
    backgroundColor: ({ type }) => getColorFromType(type, theme)
  },

  avatarArea: {
    margin: '0 1rem'
  },

  messageArea: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column'
  },

  title: {
    overflow: 'hidden',
    maxWidth: '12rem',
    fontSize: theme.size.sm,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: theme.palette.textAlt,
    marginTop: '3px'
  },

  message: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '11rem',
    color: theme.palette.textLight,
    marginTop: '4px'
  },

  closeArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '-5px 0.5rem 0 0',

    '& .icon': {
      color: theme.palette.textLight
    }
  },

  taskIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '50px',
    height: '50px'
  }
}))

export default useStyles
